import React, { useEffect }  from "react";
import Navigation from "../../Components/Navigation/Navigation";
import Banner from "../../Components/Banner";
import "./FooterPages.css";
import Footer from "../../Components/Navigation/Footer";
import GreenStamp from "../../Assets/Images/AboutUs/zen-stamp.svg";
import Terms from "../../Assets/Images/Banner/privacy.jpg";

function PrivacyPolicy() {

  useEffect(() => {
    document.title = "Privacy Policy | Zen Homes";
  }, []);

  return (
    <div className="privacyPolicyContainer">
      <Navigation
        linkColor="black"
        submenuColor="black"
        menuIconColor="black"
      />
      <Banner title="Privacy Policy" backgroundImage={Terms} />

      <div className="informationContainer">
        <div className="intro">
          <img src={GreenStamp} className="termsStamp" alt="Zen Stamp" />
          <h3>GDPR & Handling Data</h3>
          <p>
            We take personal and sensitive information very seriously at Zen
            Homes to ensure you have peace of mind when sharing any data with
            us, may this be personal details about yourself and others or phone
            numbers and address details.
          </p>
          <h3>Landlord & Vendors </h3>
          <p>
            We ensure that once you have given information that might be
            sensitive via email, phone or other methods of transfer, it is vital
            for us to keep this data safe and secure. We store all this
            information in a password-protected file for our eyes only so in any
            event the data cannot be leaked or shared to anybody.{" "}
          </p>
          <p>
            Once we receive your data from various sending sources, we delete
            the information once it has been stored in our password protected
            files. We also encourage you to send ID’s and other sensitive
            documents via what’s app, being end to end encrypted rather than
            email as they can be easily intercepted and hacked by individuals.
          </p>
          <h3>Buyers & Tenants</h3>
          <p>
            We use a password protection estate agent system which enables us to
            store all your information on, again for our eyes only and staff
            members of Zen Homes. We regularly maintain and upgrade our systems
            to ensure we have the latest software to store your information as
            securely as possible, in any event you can request your details to
            be removed, and we can do so with immediate effect.
          </p>
          <h3>Physical Office Copies </h3>
          <p>
            If we require you to come into our office to verify or share
            certified copies of ID’s and other related documents, we store all
            in our office for which is safely filed away with only Zen Homes
            staff having access to them. You can request at any given moment for
            those details to be discarded and we shall shred all information
            held in relation to your file and have them disposed accordingly.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
